export default {
  slug: 'ws-image',
};
